/**
 * Calendar Integration Utilities
 * Generate calendar links for Google Calendar, Apple Calendar, Outlook, etc.
 */

/**
 * Format date for calendar links (YYYYMMDDTHHMMSSZ)
 */
function formatCalendarDate(dateString) {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}${month}${day}`;
}

/**
 * Generate Google Calendar link
 */
export function generateGoogleCalendarLink(title, date, notes = '') {
  const dateFormatted = formatCalendarDate(date);
  const endDate = dateFormatted; // All day event
  
  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: title,
    dates: `${dateFormatted}/${dateFormatted}`,
    details: notes || 'Remindora ile eklendi',
    location: 'Türkiye'
  });
  
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}

/**
 * Generate Apple Calendar (.ics) content
 */
export function generateICSFile(title, date, notes = '') {
  const dateFormatted = formatCalendarDate(date);
  
  const icsContent = `BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//Remindora//TR
BEGIN:VEVENT
UID:${Date.now()}@remindora.com
DTSTAMP:${dateFormatted}T000000Z
DTSTART;VALUE=DATE:${dateFormatted}
DTEND;VALUE=DATE:${dateFormatted}
SUMMARY:${title}
DESCRIPTION:${notes || 'Remindora ile eklendi'}
STATUS:CONFIRMED
SEQUENCE:0
END:VEVENT
END:VCALENDAR`;

  return icsContent;
}

/**
 * Download ICS file (for Apple Calendar, Outlook)
 */
export function downloadICSFile(title, date, notes = '') {
  const icsContent = generateICSFile(title, date, notes);
  const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `${title.replace(/[^a-z0-9]/gi, '_')}_remindora.ics`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

/**
 * Generate Outlook.com calendar link
 */
export function generateOutlookLink(title, date, notes = '') {
  const dateFormatted = formatCalendarDate(date);
  
  const params = new URLSearchParams({
    path: '/calendar/action/compose',
    rru: 'addevent',
    subject: title,
    startdt: `${dateFormatted}T000000Z`,
    enddt: `${dateFormatted}T235959Z`,
    body: notes || 'Remindora ile eklendi',
    location: 'Türkiye'
  });
  
  return `https://outlook.live.com/calendar/0/deeplink/compose?${params.toString()}`;
}

/**
 * Generate Yahoo Calendar link
 */
export function generateYahooLink(title, date, notes = '') {
  const dateFormatted = formatCalendarDate(date);
  
  const params = new URLSearchParams({
    v: '60',
    title: title,
    st: `${dateFormatted}T000000Z`,
    et: `${dateFormatted}T235959Z`,
    desc: notes || 'Remindora ile eklendi',
    in_loc: 'Türkiye'
  });
  
  return `https://calendar.yahoo.com/?${params.toString()}`;
}
